import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const getStatisticsProductFilter = productType => {
	const parsedProductType = parseInt(productType);

	if (parsedProductType !== PRODUCT_TYPE_EVO && parsedProductType !== PRODUCT_TYPE_NOVA) {
		return {};
	}

	return { ProductID: parsedProductType };
};
